var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66653 2.99998V0.99998C2.66653 0.631793 2.96501 0.333313 3.3332 0.333313H11.3332C11.7014 0.333313 11.9999 0.631793 11.9999 0.99998V10.3333C11.9999 10.7015 11.7014 11 11.3332 11H9.3332V12.9994C9.3332 13.3679 9.03327 13.6666 8.662 13.6666H0.671107C0.300393 13.6666 0 13.3702 0 12.9994L0.0017333 3.66723C0.00179997 3.29872 0.30176 2.99998 0.672947 2.99998H2.66653ZM1.33495 4.33331L1.33346 12.3333H7.99987V4.33331H1.33495ZM3.99987 2.99998H9.3332V9.66665H10.6665V1.66665H3.99987V2.99998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.3d047a11907400d1b02b8cebffa8d54a.svg";
export { ForwardRef as ReactComponent };